<template>
  <div>
    <b-navbar toggleable="lg">
      <b-navbar-brand href="#">CoCoMap (beta)</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="#">Link</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown text="Lang" right>
            <b-dropdown-item href="#">EN</b-dropdown-item>
            <b-dropdown-item href="#">ES</b-dropdown-item>
            <b-dropdown-item href="#">RU</b-dropdown-item>
            <b-dropdown-item href="#">FA</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'Navbar', 
}
</script>

<style>
.navbar, .footer {
    background-color: #1a1a1a !important;  
}

.navbar-light .navbar-nav .nav-link {
    color:white !important;
}

a:hover, .navbar-brand{
  color: #e43e74 !important;
}

</style>
